<template>
  <div :class="`wind-compass`" v-tooltip="objDesc">
    <svg viewBox="0 0 100 100" class="compass">
      <!-- Tick marks -->
      <g>
        <line
          v-for="i in ticks"
          :key="i"
          :x1="50 + 44 * Math.cos((i * 10 - 90) * Math.PI / 180)"
          :y1="50 + 44 * Math.sin((i * 10 - 90) * Math.PI / 180)"
          :x2="50 + 48 * Math.cos((i * 10 - 90) * Math.PI / 180)"
          :y2="50 + 48 * Math.sin((i * 10 - 90) * Math.PI / 180)"
          stroke="#ffffffaa"
          stroke-width="0.5"
        />
      </g>

      <!-- Cardinal points -->
      <text
        v-for="(label, i) in directions"
        :key="label"
        :x="50 + 44 * Math.cos((i * 90 - 90) * Math.PI / 180)"
        :y="50 + 44 * Math.sin((i * 90 - 90) * Math.PI / 180) + 2"
        text-anchor="middle"
        font-size="8"
        font-weight="bold"
        fill="#fcfaf2"
      >
        {{ label }}
      </text>

      <!-- Arrow (rotated from wind source) -->
      <g :style="arrowStyle">
        <!-- Shaft -->
        <rect x="48.5" y="15" width="3" height="15" fill="#fcfaf2" rx="1" />
        <rect x="48.5" y="70" width="3" height="15" fill="#fcfaf2" rx="1" />
        <!-- Tip -->
        <polygon points="50,90 56,80 44,80" fill="#fcfaf2" />
        <!-- Circle base -->
        <circle cx="50" cy="18" r="5" fill="#fcfaf2" />
      </g>

      <!-- Wind speed -->
      <text x="50%" y="48%" text-anchor="middle" font-size="12" font-weight="bold" fill="#fcfaf2">
        {{ label }}
      </text>
      <text x="50%" y="59%" text-anchor="middle" font-size="7" fill="#fcfaf2">
        {{ value.value }} {{ value.unit }}
      </text>
    </svg>
  </div>
</template>


<script>
import { defineComponent } from "vue";
// import dialogChartSingle from '@/components/dialog/chartSingle.vue';

export default defineComponent({
  name: "widgetWindDirection",
  setup() {},
  components: {
    // dialogChartSingle,
  },
  props: {
    label: {
      type: String,
      required: false
    },
    value: {
      type: Object,
      required: true
    },
    icon: {
      type: String,
      required: false
    },
    colorActive: {
      type: String,
      required: false
    },
    colorInactive: {
      type: String,
      required: false
    },
    colorText: {
      type: String,
      required: false
    },
    size: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      showChart1: false,
    }
  },
  watch: {

  },
  computed: {
    iconLabel: function () {
      if (this.label !== undefined) return this.label;
      if (this.value.label !== undefined) return this.value.label;
      return '';
    },
    iconSymbol: function () {
      if (this.icon !== undefined) return this.icon;
      else return this.value.icon;
    },
    colorSymbol() {
      if (this.value.value) {
        if (this.colorActive !== undefined) return this.colorActive;
        else return `fg-lightGreen`;
      } else {
        if (this.colorInactive !== undefined) return this.colorInactive;
        else return `fg-darkGray`;
      }
    },
    colorTextLabel() {
      if (this.colorText !== undefined) return this.colorText;
      else return `fg-gray`;
    },
    isRecord() {
      if (typeof(this.value) === "object") {
        if (this.value.record === "true") return true;
      }
      return false;
    },
    objLabel() {
      if (this.value.label) return this.value.label;
      else return "";
    },
    objDesc() {
      if (this.value.description) return this.value.description;
      else return "";
    },
    showPointer() {
      if (this.isRecord) return "cursor-pointer";
      else return "";
    },
    arrowStyle() {
      return ({
        transform: `rotate(${this.value.value}deg)`,
        transformOrigin: '50% 50%',
        transition: 'transform 0.5s ease-in-out'
      });
    },
    directions() {
      return ['N', 'O', 'S', 'W'];
    },
    ticks() {
      const totalTicks = 36;
      const skipIndexes = [0, 9, 18, 27];
      return Array.from({ length: totalTicks }, (_, i) => i).filter(i => !skipIndexes.includes(i))
    },
  },
  mounted() {
  },
  methods: {
    showChart(value) {
      if (this.isRecord) {
        if (value === 'value1') this.showChart1 = true;
      }
    },
  },
});
</script>

<style lang="scss" scoped>
.wind-compass {
  background: radial-gradient(circle at center, #0089a7, #0b346e);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.3em;
}
.wind-compass2 {
  background: radial-gradient(circle at center, #0077b6, #005f8a);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.compass {
  width: 100%;
  height: 100%;
}
</style>